import React, {useState, useEffect} from "react";
import {useState as useAppState} from "../state/useState";
import {order} from "../service/RechargeService";
import {redirectTo} from "../state/action";
import {checkStatus} from "../service/RechargeService";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from 'react-loader-spinner';


export function StatusTimeout({history, uuid}) {


    return <>
        <div class="page_title2">
            <div class="container">

                <div className="title"><h1>Obrada transakcije...</h1></div>
            </div>
        </div>


        <div class="clearfix"></div>

        <div class="container">

            <div class="content_fullwidth">

                <div class="reg_form">

                    <p><h3 class="nocaps"> Sistem nije dobio podatke u predvidjenom intervalu. Molim te sačuvaj podatke
                        o transakciji i kontaktiraj
                        korisničku službu!</h3>
                    </p>
                    <blockquote><p>Transakcija: <strong>{uuid}</strong></p></blockquote>

                    <p></p>


                    <p></p>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>


                    <div class="left"><a href="javascript:undefined" onClick={() => history.push("/")} class="knowmore_but"><i
                        class="fa fa-hand-o-left fa-lg"></i> NAZAD</a></div>
                </div>


            </div>

        </div>

        <div class="clearfix margin_top7"></div>

        <div class="clearfix"></div>

    </>
}
